import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'a-status',
    templateUrl: './a-status.component.html',
    styleUrls: ['./a-status.component.scss'],
    standalone: false
})
export class AStatusComponent implements OnInit {

  @Input()
    public state: State = 'DEFAULT';
  @Input()
  public date: string;

  public fromState = fromState;

    @Input()
  public pulse: boolean;

    constructor() { }

    ngOnInit(): void {
    }

}

export type State = 'NEW' | 'DEFAULT' | 'DRAFT' | 'INPROGRESS' | 'FINISH' | 'PAID' | 'TAG' | 'TOPAY' | 'TOPAYWITHIN';

export function fromState(state: State): string {
    switch (state) {
        case 'NEW':
            return '_new';
        case 'DEFAULT':
            return '';
        case 'DRAFT':
            return '_draft';
        case 'INPROGRESS':
            return '_inProgress';
        case 'FINISH':
            return '_finish';
        case 'PAID':
            return '_paid';
        case 'TAG':
            return '_tag';
        case 'TOPAY':
            return '_toPay';
        case 'TOPAYWITHIN':
            return '_toPayWithin';
    }
}
